export const githubHome = "https://github.com/SahiDemon";
export function scopedGithubUrl(value: string, base = githubHome): string | null {
  try {
    if (value.length > 2048 || /[\\\u0000-\u001f]/.test(value)) return null;
    const url = new URL(value, base);
    const parts = url.pathname.split("/").filter(Boolean).map(part => decodeURIComponent(part));
    if (url.protocol !== "https:" || url.hostname !== "github.com" || url.port || url.username || url.password ||
        parts[0]?.toLowerCase() !== "sahidemon" || parts.some(part => /[\\/%\u0000-\u001f]/.test(part) || part === "." || part === "..")) return null;
    return url.href;
  } catch { return null; }
}
